// Mega menu: open on hover with smooth slide-down (desktop only)
if (window.matchMedia('(min-width: 990px)').matches) {
  document.querySelectorAll('.header__inline-menu header-menu').forEach(function(hm) {
    var details = hm.querySelector('details');
    if (!details) return;
    var content = details.querySelector('.mega-menu__content') || details.querySelector('.header__submenu');
    if (!content) return;
    var closeTimeout;

    function openMenu() {
      clearTimeout(closeTimeout);
      details.setAttribute('open', '');
      void content.offsetHeight;
      details.classList.add('korallo-mega-open');
    }

    function scheduleClose() {
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(function() {
        details.classList.remove('korallo-mega-open');
        setTimeout(function() {
          if (!details.classList.contains('korallo-mega-open')) {
            details.removeAttribute('open');
          }
        }, 280);
      }, 100);
    }

    // Listen on both the trigger (li/hm) and the dropdown content
    // to bridge the visual gap between them
    var li = hm.closest('li') || hm;
    li.addEventListener('mouseenter', openMenu);
    li.addEventListener('mouseleave', scheduleClose);
    content.addEventListener('mouseenter', openMenu);
    content.addEventListener('mouseleave', scheduleClose);
  });
}
